import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface AppUpdatedPageProps {
  /** Mensaje técnico del error, para soporte. Opcional. */
  detail?: string;
}

// Pantalla para el chunk que el deploy se llevó: la pestaña quedó con un build
// viejo y el asset hasheado ya no existe. No es un error del usuario ni del
// backend, así que el tono es informativo y la única acción es recargar.
export const AppUpdatedPage = ({ detail }: AppUpdatedPageProps) => {
  const handleReload = (): void => {
    window.location.reload();
  };

  return (
    <div className="bg-bg flex min-h-screen items-center justify-center p-6">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="items-center gap-2">
          <div
            className="bg-surface-2 flex h-16 w-16 items-center justify-center rounded-full"
            aria-hidden="true"
          >
            <RefreshCw className="text-info h-8 w-8" />
          </div>
          <CardTitle className="text-2xl">La aplicación se actualizó</CardTitle>
          <CardDescription>
            Se publicó una versión nueva mientras esta pestaña estaba abierta. Recarga para seguir
            trabajando con la última versión.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          {detail ? (
            <p
              data-testid="app-updated-detail"
              className="border-border bg-surface-2 text-text-muted rounded-md border p-3 text-left font-mono text-xs"
            >
              {detail}
            </p>
          ) : null}
          <Button type="button" onClick={handleReload} className="self-center">
            Recargar
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
